var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(-9942.619 -7527)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 16,
    height: 20,
    transform: "translate(9942.619 7527)",
    fill: "none",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M9955.12,7534.784a.643.643,0,0,0-.644.643v6.2a1.233,1.233,0,0,1-1.293,1.163h-5.131a1.236,1.236,0,0,1-1.293-1.163v-6.2a.643.643,0,0,0-1.286,0v6.2a2.52,2.52,0,0,0,2.579,2.449h5.131a2.519,2.519,0,0,0,2.579-2.449v-6.2A.643.643,0,0,0,9955.12,7534.784Zm.643-2.929h-2.571v-1.286a.643.643,0,0,0-.644-.643h-3.858a.643.643,0,0,0-.644.643v1.286h-2.572a.643.643,0,0,0,0,1.286h10.289a.643.643,0,1,0,0-1.286Zm-6.43,0v-.643h2.572v.643Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.5a28fa341ba5402a6de6c9ac4f76b791.svg";
export { ForwardRef as ReactComponent };